import axios from './axios'
import { ElLoading } from 'element-plus'

export function listCoupon (param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/vip_coupon/group', param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}

export function consumeCoupon (param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/vip_coupon/consume', param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}

export function scanCoupon (param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/vip_coupon/scan', param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}

export function listCouponGoods (param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/vip_coupon/goods', param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}

export function writeoffCoupon (param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/vip_coupon/writeoff', param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}

export function topupCoupon (param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/vip_coupon/topup', param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}
